module.exports = __webpack_public_path__ + "img/across_bar_chart.c0632709.png";